import { useState } from 'react';
import './App.css';
import AllAlgorithmsSelector from './Components/AllAlgorithmsSelector';
import { ProgressSpinner } from 'primereact/progressspinner';
import EncodeDecodeSwitch from './Components/EncodeDecodeSwitch';
import { CompressionResponse, EncoderObject } from './Types/AllTypes';
import SelectedAlgorithmsDisplay from './Components/SelectedAlgorithmsDisplay';
import SubmitButton from './Components/SubmitButton';
import InputTextBox from './Components/InputTextBox';
import { LocalHost } from './Utils/Defaults';
import axios from 'axios';
import ResultStep from './Components/ResultStep';
import { Button } from 'primereact/button';
import { TEST_DATA } from './Utils/TestData';
import HuffmanCodeTable from './Components/HuffmanCodeTable';

function App() {
  const [compressionResponse, setCompressionResponse] = useState<CompressionResponse>();
  const [huffmanDictionary, setHuffmanDictionary] = useState<Record<string, number>>();
  const [isLoading, setIsLoading] = useState(false);

  const [selectedAlgorithms, setSelectedAlgorithms] = useState<EncoderObject[]>([]);
  const [submittedAlgorithms, setSubmittedAlgorithms] = useState<EncoderObject[]>([]);


  const [inputText, setInputText] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [inputTextByte, setInputTextByte] = useState<number[]>();
  const [encodeOn, setEncodeOn] = useState<boolean>(true);

  const handleEncodeDecodeSwitch = () => {
    if (compressionResponse) {
      setInputText(compressionResponse.humanReadableVersions.pop() ?? "");
      setInputTextByte(compressionResponse.resultsBytes.pop() ?? []);
      setCompressionResponse(undefined);

      // Also reverse the order of the selectedAlgorithms
      // Don't mutate state directly!
      const newSelectedAlgorithms = [...selectedAlgorithms];
      newSelectedAlgorithms.reverse();
      setSelectedAlgorithms(newSelectedAlgorithms);
    }
  }

  const handleSubmitButton = () => {
    setIsLoading(true)
    setErrorMessage("")
    setCompressionResponse(undefined);

    const endpoint = encodeOn ? "/encode" : "/decode";
    const inputTextParamName = encodeOn ? "plaintext" : "ciphertext";
    let selectedAlgorithmsCodes = selectedAlgorithms.map((item: any) => item.code)
    const params = encodeOn ?
      {
        tools: selectedAlgorithmsCodes,
        [inputTextParamName]: inputText, // computed property names from old ecmascript
      }
      :
      {
        tools: selectedAlgorithmsCodes,
        [inputTextParamName]: inputText, // computed property names from old ecmascript
        listToCol: huffmanDictionary,
        compressedbytes: inputTextByte,
      }

    console.log(huffmanDictionary)
    axios.post(LocalHost + endpoint, params)
      .then((response: any) => {
        const responseObject: CompressionResponse = response.data;
        setCompressionResponse(responseObject);
        setInputTextByte(responseObject.resultsBytes[0]);
        console.log(responseObject.resultsBytes[0])
        setSubmittedAlgorithms(selectedAlgorithms)
        if (responseObject?.listToCol) {
          setHuffmanDictionary(responseObject?.listToCol);
        } else {
          setHuffmanDictionary(undefined);
        }
        console.log("response object below:")
        console.log(responseObject)
      })
      .catch((error: any) => {
        console.error(error);
        setErrorMessage("internal server error :/ please make an issue on github");
      }).finally(() => {
        setIsLoading(false);
      });
  }

  const setRandomTestData = () => {
    const randomQuote = TEST_DATA[Math.floor(Math.random() * TEST_DATA.length)];
    setInputText(randomQuote);
  }

  return (
    <div className="mainContainer App ">
      <div className='leftDashboardSection'>

        <EncodeDecodeSwitch encodeOn={encodeOn} setEncodeOn={setEncodeOn} handleEncodeDecodeSwitch={handleEncodeDecodeSwitch} />
        <AllAlgorithmsSelector selectedAlgorithms={selectedAlgorithms} setSelectedAlgorithms={setSelectedAlgorithms} />
        <SelectedAlgorithmsDisplay selectedAlgorithms={selectedAlgorithms} setSelectedAlgorithms={setSelectedAlgorithms} />
        <SubmitButton encodeOn={encodeOn} handleSubmitButton={handleSubmitButton} />

      </div>
      <div className='resultsSection'>
        <InputTextBox encodeOn={encodeOn} value={inputText} setValue={setInputText} byteVersion={inputTextByte} />
        <div className='resultMetadata'>
          <p>Entropy: {compressionResponse?.entropies[0]}</p>
          <p>Size: {compressionResponse?.sizes[0]}</p>
          <Button label="Sample Data" icon="pi pi-refresh" text size="small" onClick={setRandomTestData} />
        </div>

        
        {isLoading && (
          <div className='loadingState'>
            <ProgressSpinner color='purple' />
          </div>
        )}
        {errorMessage &&
          <div className='errorMessage'>
            {errorMessage}
          </div>
        }

        {/* Each result step is rendered below: */}
        {
          compressionResponse && compressionResponse.resultsBytes.map((item, index) => (
            <ResultStep encodedText={compressionResponse.results[index]} entropy={compressionResponse.entropies[index + 1]} size={compressionResponse.sizes[index + 1]}
              speed={compressionResponse.speeds[index]} selectedAlgorithm={submittedAlgorithms[index]}
              encodedBytes={compressionResponse.resultsBytes[index + 1]}
              humanReadableVersion={compressionResponse.humanReadableVersions[index]} />
          ))
        }
      </div>
      <div className='metadataSection'>
        {huffmanDictionary &&
          <HuffmanCodeTable huffmanDictionary={huffmanDictionary} setHuffmanDictionary={setHuffmanDictionary} />
        }
      </div>
    </div>
  );
}

export default App;
